export const apiKey = process.env.API_KEY;
export const appId = process.env.API_ID;
export const messageId = process.env.MESSAGE_ID;
export const authDomainKey = process.env.AUTH_DOMAIN
export const proyectId = process.env.PROYECT_ID
export const storageBucket = process.env.STORAGE_BUCKET
export const databaseURL = process.env.DATABASE_URL
export const publicKey = process.env.MJ_APIKEY_PUBLIC
export const privateKey = process.env.MJ_APIKEY_PRIVATE
export const presetName = process.env.PRESET_NAME
export const cloudName = process.env.CLOUD_NAME




